var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 511,
    height: 511,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2B50AA",
    cx: 255,
    cy: 255,
    id: "svg_5",
    rx: 255,
    ry: 255
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.793,359.032c1.093,1.002 2.46,1.549 3.736,1.549c1.275,0 2.733,-0.547 3.736,-1.549l12.575,-12.028c1.093,-1.003 1.731,-2.461 1.731,-3.919c0,-1.458 -0.638,-2.916 -1.731,-3.918l-87.295,-83.377l87.295,-83.376c1.093,-1.003 1.731,-2.461 1.731,-3.919c0,-1.458 -0.638,-2.915 -1.731,-3.918l-12.575,-12.028c-1.094,-1.002 -2.369,-1.549 -3.736,-1.549c-1.367,0 -2.734,0.547 -3.736,1.549l-104.0617,99.323c-1.0935,1.003 -1.7313,2.46 -1.7313,3.918c0,1.458 0.6378,2.916 1.7313,3.919l104.0617,99.323zm205.662,-103.242l-87.295,83.377c-1.093,1.002 -1.731,2.46 -1.731,3.918c0,1.458 0.638,2.916 1.731,3.919l12.575,12.028c1.094,1.002 2.461,1.549 3.736,1.549c1.276,0 2.734,-0.547 3.736,-1.549l104.062,-99.323c1.093,-1.003 1.731,-2.461 1.731,-3.919c0,-1.458 -0.638,-2.915 -1.731,-3.918l-104.062,-99.323c-1.093,-1.002 -2.46,-1.549 -3.736,-1.549c-1.367,0 -2.733,0.547 -3.736,1.549l-12.575,12.028c-1.093,1.003 -1.731,2.46 -1.731,3.918c0,1.458 0.638,2.916 1.731,3.919l87.295,83.376z",
    fill: "#C5D5EA",
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.064,245.585c-0.091,3.553 1.276,6.925 3.827,9.476l0.091,0.091c2.46,2.461 5.65,3.828 9.112,3.828c3.19,0 6.197,-1.185 8.566,-3.281l35.446,-31.528l0,96.68c0,7.108 5.832,12.94 12.94,12.94c7.107,0 12.939,-5.832 12.939,-12.94l0,-96.771l35.446,31.528c2.37,2.096 5.468,3.28 8.566,3.28c3.463,0 6.743,-1.366 9.203,-3.827l0.091,-0.091c2.552,-2.551 3.828,-5.832 3.828,-9.477c-0.092,-3.553 -1.55,-6.834 -4.192,-9.294l-57.225,-52.577c-2.369,-2.187 -5.467,-3.372 -8.656,-3.372c-3.19,0 -6.288,1.185 -8.657,3.372l-57.225,52.577c-2.551,2.551 -4.1,5.832 -4.1,9.386z",
    fill: "#C5D5EA",
    id: "svg_3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRounded);
export default __webpack_public_path__ + "static/media/logo-rounded.954a486592f0d451905745d96a84c91d.svg";
export { ForwardRef as ReactComponent };